import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { Component } from 'react'

export default class NotFound extends Component {
  render() {
    return (
      <div className="container section has-text-centered">
        <h1 className='title'>Oops.. Esta página não existe!</h1>
            
        <p style={{fontSize: '5rem', marginTop: '10vh'}}>
          <FontAwesomeIcon icon='tools'/>                
        </p>
      </div>
    )
  }
}
